import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const titleProps = ({ theme }) => css`
  font-weight: bold;
  color: var(--greyWolf);
  border: 1px solid var(--greyWolf);
  background-color: var(--whiteCaniche);
  text-transform: uppercase;
  font-size: ${theme.base.textSizes.M};
  border-radius: ${theme.base.gridSizes.XXS};
  margin-bottom: ${theme.base.gridSizes.S};
`;

export const TableTitle = styled(Flexer.Parent).attrs(() => ({
  p: 'XS',
}))`
  ${titleProps}
`;
